import React from 'react';
import { Text } from '@contact/ui-volta';

interface CategoriesProps {
  items: string[];
}

export const Categories: React.FC<CategoriesProps> = ({ items }) => (
  <Text variant="title" data-testid="categories">
    {items.reduce((previous, current) => {
      if (!current) {
        return previous;
      }

      if (previous) {
        return `${previous} > ${current}`;
      } else {
        return current;
      }
    }, '')}
  </Text>
);
